import React, { useState, useEffect } from "react";
import apiService from "../../service";
import { useParams } from "react-router-dom";
import "../PreviewComponent/PreviewComponent.css";
import "../Invoice/invoicePreview.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PreviewComponent from "../Preview/Preview";

const InvoicePreview = () => {
  const { id } = useParams();
  const [dataAvailable, setDataAvailable] = useState(null);

  //inVoice Preview  get api calling here
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await apiService.getInvoiceDataById(id);
        setDataAvailable(data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, [id]);

  const breadCrumbArray = [
    {
      name: "Invoice",
      color: "#000000",
      underline: "none",
      href: "/doc-ai/invoice",
    },
    {
      name: dataAvailable?.file_name,
      color: "#767676",
      underline: "none",
    },
  ];

  return (
    <>
      if (dataAvailable && dataAvailable !== null) {
        <PreviewComponent
          dataAvailable={dataAvailable}
          setDataAvailable={setDataAvailable}
          breadCrumbNames={breadCrumbArray}
          id={id}
        />
      }
    </>
  );
};

export default InvoicePreview;
